'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  agentState: null,
  agentType: null,
  avatar: null,
  bot: false,
  email: null,
  firstName: null,
  lastName: null,
  meetingsLinkUrl: null,
  meetingsLinkText: null,
  online: false,
  portalId: _hubspot2.default.get(),
  salesPro: false,
  userId: null,
  assignable: true
}, 'Responder');
module.exports = exports['default'];